module.exports = __webpack_public_path__ + "img/art-page2-img-1.0c13c14d.jpg";